import { render, staticRenderFns } from "./ImsUserSearchDialog.vue?vue&type=template&id=4a9f9f59&scoped=true&"
import script from "./ImsUserSearchDialog.vue?vue&type=script&lang=js&"
export * from "./ImsUserSearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f9f59",
  null
  
)

export default component.exports